import {useEffect, useState} from 'react';

const getSize = () => ({
    isMobile: window.innerWidth < 480,
    isCompact: window.innerWidth < 600,
    isSidebarOpen: window.innerWidth >= 1024,
});

const useScreenSize = () => {
    const [size, setSize] = useState(getSize);

    useEffect(() => {
        const handler = () => setSize(getSize());
        window.addEventListener('resize', handler);
        return () => window.removeEventListener('resize', handler);
    }, []);

    return size;
};

export default useScreenSize;